// @ts-nocheck
import { ReactComponent as Icon } from '../../assets/icons/signet.svg';

export default function () {
  return <Icon className="MuiSvgIcon-root" alt="Logo" aria-label="Logo" />;
}
